import { Col, Row, Button } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

import BasicSpinner from '../common/basic-spinner';
import PaginatedList from '../common/pagination';

import { fetchPublicCollections } from '../../utils/fetch-helpers'

//================================================================

export default function PublicCollectionsPage(){

  const [collections, setCollections] = useState([]);

  //----------------------------------------------------------------

  const fetchCollections = async (signal) => {
    setCollections(await fetchPublicCollections(signal));
  }

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchCollections(signal);

    return () => {
      // Cancel the request when the component unmounts
      abortController.abort();
    };
  }, []);

  //----------------------------------------------------------------

  return(
    <>
      {!collections ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>
          <Row className="mb-2">
            <Col className="h4 text-start">Public Collections:</Col>
          </Row>
          <PaginatedList
            key='user-collections'
            list={collections}
            type='collection'
          />
        </>
      }
    </>
  );
}
